// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../img/icon_print.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../img/icon_print_vert_nouvelle_aquitaine.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../img/icon_print_vert_occitanie.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../img/icon_print_vert_paysdelaloire.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../img/icon_print_vert_bretagne.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../img/icon_print_vert_corse.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../img/fullscreen-aura-ee.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../img/fullscreen-nouvelle-aquitaine.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../img/fullscreen-occitanie.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../img/fullscreen-paysdelaloire.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../img/fullscreen-bretagne.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../img/fullscreen-corse.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../img/exit_fullscreen-aura-ee.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../img/exit_fullscreen-nouvelle-aquitaine.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../img/exit_fullscreen-occitanie.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../img/exit_fullscreen-paysdelaloire.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../img/exit_fullscreen-bretagne.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../img/exit_fullscreen-corse.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../img/logo_TerriSTORY_region_nouvelle_aquitaine_small.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../img/logo_TerriSTORY_region_occitanie.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../img/logo_TerriSTORY_region_aura_small.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../img/logo_TerriSTORY_region_paysdelaloire.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../img/logo_TerriSTORY_region_bretagne.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../img/logo_TerriSTORY_region_corse.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#sankey {
    position: inherit;
}

.gg_label {
    font-family: Cormorant;
}

#sankey-content {
    height: 100%;
    position: relative;
    margin-bottom: 100px;
}

#sankey-content .export-date {
    visibility: hidden;
    font-size: 14px;
    text-align: right;
    margin-right: 30px;
    margin-top: 10px;
    margin-bottom: 10px;
    height: 24px;
}

.sankey_copyright {
    text-align: right;
    font-size: larger;
    font-style: italic;
    margin-right: 20px;
    margin-left: 20px;
}

.sankey_intro {
    font-size: larger;
    text-align: left;
    margin-right: 20px;
    margin-left: 20px;
}

#sankey_with_buttons {
    background-color: white;
    border: 1px solid #ddd;
    overflow: scroll;
}

.sankey_fullscreen {
    text-align: right;
    margin-bottom: -60px;
    margin-top: 30px;
    margin-right: 40px;
    margin-left: 30px;
    position: relative;
    z-index: 100;
}

.sankey-print-button,
.sankey-printing-button {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center;
    width: 20px;
    height: 20px;
    display: inline-block;
    position: absolute;
    z-index: 100;
    right: 80px;
}
.loader.sankey-printing-button {
    width: 20px;
    height: 20px;
}
.sankey-print-button-vert-france {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center;
}
.sankey-print-button-vert-nouvelle-aquitaine {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center
        center;
}
.sankey-print-button-vert-occitanie {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat center center;
}
.sankey-print-button-vert-paysdelaloire {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat center center;
}
.sankey-print-button-vert-bretagne {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) no-repeat center center;
}
.sankey-print-button-vert-corse {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) no-repeat center center;
}

.sankey-fullscreen-button,
.sankey-exit-fullscreen-button {
    width: 20px;
    height: 20px;
    display: inline-block;
    vertical-align: top;
    margin-left: 10px;
    position: absolute;
    z-index: 100;
    right: 40px;
}
.sankey-fullscreen-button-vert-aura-ee {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) no-repeat center center;
}
.sankey-fullscreen-button-vert-nouvelle-aquitaine {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) no-repeat center center;
}
.sankey-fullscreen-button-vert-occitanie {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) no-repeat center center;
}
.sankey-fullscreen-button-vert-paysdelaloire {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) no-repeat center center;
}
.sankey-fullscreen-button-vert-bretagne {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) no-repeat center center;
}
.sankey-fullscreen-button-vert-corse {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) no-repeat center center;
}
.sankey-exit-fullscreen-button-vert-aura-ee {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) no-repeat center center;
}
.sankey-exit-fullscreen-button-vert-nouvelle-aquitaine {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) no-repeat center
        center;
}
.sankey-exit-fullscreen-button-vert-occitanie {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) no-repeat center center;
}
.sankey-exit-fullscreen-button-vert-paysdelaloire {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_15___}) no-repeat center center;
}
.sankey-exit-fullscreen-button-vert-bretagne {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_16___}) no-repeat center center;
}
.sankey-exit-fullscreen-button-vert-corse {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_17___}) no-repeat center center;
}

.sankey-confidential-data {
    height: 85px;
    padding-top: 40px;
    text-align: center;
}

.sankey-tooltip:empty {
    display: none;
}

.front-of-sankey {
    z-index: 10;
    position: relative;
}

.close-big-sankey {
    z-index: 10;
    position: fixed;
}

.logo-sankey-print {
    visibility: hidden;
    position: fixed;
    top: 80px;
    right: 20px;
    width: 450px;
    height: 90px;
    z-index: 10;
}

.logo-sankey-vert-nouvelle-aquitaine {
    background: rgba(255, 255, 255, 1)
        url(${___CSS_LOADER_URL_REPLACEMENT_18___}) no-repeat
        center center;
    background-position: right;
    background-size: auto 90px;
}

.logo-sankey-vert-occitanie {
    background: rgba(255, 255, 255, 1)
        url(${___CSS_LOADER_URL_REPLACEMENT_19___}) no-repeat center center;
    background-position: right;
    background-size: auto 90px;
}

.logo-sankey-vert-aura-ee {
    background: rgba(255, 255, 255, 1)
        url(${___CSS_LOADER_URL_REPLACEMENT_20___}) no-repeat center center;
    background-position: right;
    background-size: auto 90px;
}

.logo-sankey-vert-paysdelaloire {
    background: rgba(255, 255, 255, 1)
        url(${___CSS_LOADER_URL_REPLACEMENT_21___}) no-repeat center center;
    background-position: right;
    background-size: auto 90px;
}

.logo-sankey-vert-bretagne {
    background: rgba(255, 255, 255, 1) url(${___CSS_LOADER_URL_REPLACEMENT_22___})
        no-repeat center center;
    background-position: right;
    background-size: auto 90px;
}

.logo-sankey-vert-corse {
    background: rgba(255, 255, 255, 1) url(${___CSS_LOADER_URL_REPLACEMENT_23___})
        no-repeat center center;
    background-position: right;
    background-size: auto 90px;
}
`, "",{"version":3,"sources":["webpack://./src/style/sankey.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;;IAEI,2EAAgE;IAChE,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,YAAY;IACZ,WAAW;AACf;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,2EAAgE;AACpE;AACA;IACI;cACU;AACd;AACA;IACI,2EAA+E;AACnF;AACA;IACI,2EAAmF;AACvF;AACA;IACI,2EAA8E;AAClF;AACA;IACI,2EAA2E;AAC/E;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,WAAW;AACf;AACA;IACI,2EAAwE;AAC5E;AACA;IACI,2EAAmF;AACvF;AACA;IACI,2EAA0E;AAC9E;AACA;IACI,2EAA8E;AAClF;AACA;IACI,4EAAyE;AAC7E;AACA;IACI,4EAAsE;AAC1E;AACA;IACI,4EAA6E;AACjF;AACA;IACI;cACU;AACd;AACA;IACI,4EAA+E;AACnF;AACA;IACI,4EAAmF;AACvF;AACA;IACI,4EAA8E;AAClF;AACA;IACI,4EAA2E;AAC/E;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,SAAS;IACT,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,WAAW;AACf;;AAEA;IACI;;qBAEiB;IACjB,0BAA0B;IAC1B,0BAA0B;AAC9B;;AAEA;IACI;wEAC8E;IAC9E,0BAA0B;IAC1B,0BAA0B;AAC9B;;AAEA;IACI;wEAC+E;IAC/E,0BAA0B;IAC1B,0BAA0B;AAC9B;;AAEA;IACI;wEACkF;IAClF,0BAA0B;IAC1B,0BAA0B;AAC9B;;AAEA;IACI;+BAC2B;IAC3B,0BAA0B;IAC1B,0BAA0B;AAC9B;;AAEA;IACI;+BAC2B;IAC3B,0BAA0B;IAC1B,0BAA0B;AAC9B","sourcesContent":["#sankey {\n    position: inherit;\n}\n\n.gg_label {\n    font-family: Cormorant;\n}\n\n#sankey-content {\n    height: 100%;\n    position: relative;\n    margin-bottom: 100px;\n}\n\n#sankey-content .export-date {\n    visibility: hidden;\n    font-size: 14px;\n    text-align: right;\n    margin-right: 30px;\n    margin-top: 10px;\n    margin-bottom: 10px;\n    height: 24px;\n}\n\n.sankey_copyright {\n    text-align: right;\n    font-size: larger;\n    font-style: italic;\n    margin-right: 20px;\n    margin-left: 20px;\n}\n\n.sankey_intro {\n    font-size: larger;\n    text-align: left;\n    margin-right: 20px;\n    margin-left: 20px;\n}\n\n#sankey_with_buttons {\n    background-color: white;\n    border: 1px solid #ddd;\n    overflow: scroll;\n}\n\n.sankey_fullscreen {\n    text-align: right;\n    margin-bottom: -60px;\n    margin-top: 30px;\n    margin-right: 40px;\n    margin-left: 30px;\n    position: relative;\n    z-index: 100;\n}\n\n.sankey-print-button,\n.sankey-printing-button {\n    background: url(\"../img/icon_print.png\") no-repeat center center;\n    width: 20px;\n    height: 20px;\n    display: inline-block;\n    position: absolute;\n    z-index: 100;\n    right: 80px;\n}\n.loader.sankey-printing-button {\n    width: 20px;\n    height: 20px;\n}\n.sankey-print-button-vert-france {\n    background: url(\"../img/icon_print.png\") no-repeat center center;\n}\n.sankey-print-button-vert-nouvelle-aquitaine {\n    background: url(\"../img/icon_print_vert_nouvelle_aquitaine.png\") no-repeat center\n        center;\n}\n.sankey-print-button-vert-occitanie {\n    background: url(\"../img/icon_print_vert_occitanie.png\") no-repeat center center;\n}\n.sankey-print-button-vert-paysdelaloire {\n    background: url(\"../img/icon_print_vert_paysdelaloire.png\") no-repeat center center;\n}\n.sankey-print-button-vert-bretagne {\n    background: url(\"../img/icon_print_vert_bretagne.png\") no-repeat center center;\n}\n.sankey-print-button-vert-corse {\n    background: url(\"../img/icon_print_vert_corse.png\") no-repeat center center;\n}\n\n.sankey-fullscreen-button,\n.sankey-exit-fullscreen-button {\n    width: 20px;\n    height: 20px;\n    display: inline-block;\n    vertical-align: top;\n    margin-left: 10px;\n    position: absolute;\n    z-index: 100;\n    right: 40px;\n}\n.sankey-fullscreen-button-vert-aura-ee {\n    background: url(\"../img/fullscreen-aura-ee.svg\") no-repeat center center;\n}\n.sankey-fullscreen-button-vert-nouvelle-aquitaine {\n    background: url(\"../img/fullscreen-nouvelle-aquitaine.svg\") no-repeat center center;\n}\n.sankey-fullscreen-button-vert-occitanie {\n    background: url(\"../img/fullscreen-occitanie.svg\") no-repeat center center;\n}\n.sankey-fullscreen-button-vert-paysdelaloire {\n    background: url(\"../img/fullscreen-paysdelaloire.svg\") no-repeat center center;\n}\n.sankey-fullscreen-button-vert-bretagne {\n    background: url(\"../img/fullscreen-bretagne.svg\") no-repeat center center;\n}\n.sankey-fullscreen-button-vert-corse {\n    background: url(\"../img/fullscreen-corse.svg\") no-repeat center center;\n}\n.sankey-exit-fullscreen-button-vert-aura-ee {\n    background: url(\"../img/exit_fullscreen-aura-ee.svg\") no-repeat center center;\n}\n.sankey-exit-fullscreen-button-vert-nouvelle-aquitaine {\n    background: url(\"../img/exit_fullscreen-nouvelle-aquitaine.svg\") no-repeat center\n        center;\n}\n.sankey-exit-fullscreen-button-vert-occitanie {\n    background: url(\"../img/exit_fullscreen-occitanie.svg\") no-repeat center center;\n}\n.sankey-exit-fullscreen-button-vert-paysdelaloire {\n    background: url(\"../img/exit_fullscreen-paysdelaloire.svg\") no-repeat center center;\n}\n.sankey-exit-fullscreen-button-vert-bretagne {\n    background: url(\"../img/exit_fullscreen-bretagne.svg\") no-repeat center center;\n}\n.sankey-exit-fullscreen-button-vert-corse {\n    background: url(\"../img/exit_fullscreen-corse.svg\") no-repeat center center;\n}\n\n.sankey-confidential-data {\n    height: 85px;\n    padding-top: 40px;\n    text-align: center;\n}\n\n.sankey-tooltip:empty {\n    display: none;\n}\n\n.front-of-sankey {\n    z-index: 10;\n    position: relative;\n}\n\n.close-big-sankey {\n    z-index: 10;\n    position: fixed;\n}\n\n.logo-sankey-print {\n    visibility: hidden;\n    position: fixed;\n    top: 80px;\n    right: 20px;\n    width: 450px;\n    height: 90px;\n    z-index: 10;\n}\n\n.logo-sankey-vert-nouvelle-aquitaine {\n    background: rgba(255, 255, 255, 1)\n        url(\"../img/logo_TerriSTORY_region_nouvelle_aquitaine_small.png\") no-repeat\n        center center;\n    background-position: right;\n    background-size: auto 90px;\n}\n\n.logo-sankey-vert-occitanie {\n    background: rgba(255, 255, 255, 1)\n        url(\"../img/logo_TerriSTORY_region_occitanie.png\") no-repeat center center;\n    background-position: right;\n    background-size: auto 90px;\n}\n\n.logo-sankey-vert-aura-ee {\n    background: rgba(255, 255, 255, 1)\n        url(\"../img/logo_TerriSTORY_region_aura_small.png\") no-repeat center center;\n    background-position: right;\n    background-size: auto 90px;\n}\n\n.logo-sankey-vert-paysdelaloire {\n    background: rgba(255, 255, 255, 1)\n        url(\"../img/logo_TerriSTORY_region_paysdelaloire.png\") no-repeat center center;\n    background-position: right;\n    background-size: auto 90px;\n}\n\n.logo-sankey-vert-bretagne {\n    background: rgba(255, 255, 255, 1) url(\"../img/logo_TerriSTORY_region_bretagne.png\")\n        no-repeat center center;\n    background-position: right;\n    background-size: auto 90px;\n}\n\n.logo-sankey-vert-corse {\n    background: rgba(255, 255, 255, 1) url(\"../img/logo_TerriSTORY_region_corse.png\")\n        no-repeat center center;\n    background-position: right;\n    background-size: auto 90px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
